import * as React from 'react';
const HerpesLabialeIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M86.05 78.85c5.16-.21 9.98 1.49 13.95 5.56 11.65-11.97 30.68-3.42 44.04 13.68 0 0-11.65 23.08-44.04 23.08M100 121.17c-32.39 0-44.04-23.08-44.04-23.08 2.2-2.82 4.56-5.41 7.01-7.71"
      className="prefix__cls-2"
    />
    <path
      d="M144.04 98.09S120.9 102.2 100 102.2s-44.04-4.11-44.04-4.11"
      className="prefix__cls-2"
    />
    <circle cx={74.04} cy={84.35} r={7} className="prefix__cls-1" />
    <circle cx={74.04} cy={84.35} r={1} className="prefix__cls-1" />
  </svg>
);
export default HerpesLabialeIcon;
